import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnboardingListComponent } from './Internal-Roles/Onboarding/onboarding-list/onboarding-list.component';
import { OnboardingComponent } from './Internal-Roles/Onboarding/onboarding/onboarding.component';
import { ALMHomeComponent } from './Pages/almhome/almhome.component';
import { CredentialLibraryComponent } from './Pages/credential-library/credential-library.component';
import { SupportComponent } from './Pages/support/support.component';
import { ApiDetailsPageComponent } from './Products/BLE_API/api-details-page/api-details-page.component';
import { APILandingPageComponent } from './Products/BLE_API/api-landing-page/api-landing-page.component';
import { InventoryPageComponent } from './Products/Engage/inventory-page/inventory-page.component';
import { MobileCredLandingComponent } from './Products/NFC Creds/Mobile-Cred-Landing/mobile-cred-landing.component';
import { CanActivateService } from './Services/CanActivate/can-activate.service';
import { CallbackComponent } from './Shared Components/callback/callback.component';
import { AvailableSubsComponent } from './Subscriptions/available-subs/available-subs.component';
import { ActiveSubsComponent } from './Subscriptions/active-subs/active-subs.component';
import { ZentraAdminLandingPageComponent } from './Subscriptions/Zentra-Admin/zentra-admin-landing-page/zentra-admin-landing-page.component';
import { ZentraConfigPageComponent } from './Subscriptions/Zentra-Admin/zentra-config-page/zentra-config-page.component';
import { PropertyManagerLandingComponent } from './Subscriptions/PropertyManager/property-manager-landing/property-manager-landing.component';
import { AllSubsPageComponent } from './Subscriptions/all-subs-page/all-subs-page.component';
import { UpdatePaymentComponent } from './Subscriptions/update-payment/update-payment.component';
import { IntegratorLandingComponent } from './Subscriptions/Integrator/integrator-landing/integrator-landing.component';
import { LandingSubListPageComponent } from './Subscriptions/Overtur-Admin/landing-sub-list-page/landing-sub-list-page.component';
import { CreateTrialPageComponent } from './Subscriptions/Overtur-Admin/Create-Trial-Subs/create-trial-page/create-trial-page.component';
import { OvertursubDetailsPageComponent } from './Subscriptions/Overtur-Admin/overtursub-details-page/overtursub-details-page.component';
import { UserPermsComponent } from './Pages/Users-Perms/user-perms/user-perms.component';
import { PoDetailsPage } from './Subscriptions/Zentra-Admin/zentra-admin-po-subs-details/po-details-page/po-details-page';
import { SatAdminLandingPageComponent } from './Subscriptions/SAT-Admin/sat-admin-landing-page/sat-admin-landing-page.component';
import { SatConfigPageComponent } from './Subscriptions/SAT-Admin/sat-config-page/sat-config-page.component';

const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  { path: 'callback', component: CallbackComponent },

  {
    path: 'landing',
    component: ALMHomeComponent,
    data: { header: true },
    canActivate: [CanActivateService],
  },

  {
    path: 'credential-library',
    component: CredentialLibraryComponent,
    canActivate: [CanActivateService],
    data: { header: true },
  },

  {
    path: 'nfc-mobile-credentials',
    component: MobileCredLandingComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },

  {
    path: 'support-ticket',
    component: SupportComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },
  {
    path: 'support-ticket-onboarding',
    component: SupportComponent,
    data: { header: true },
    canActivate: [CanActivateService],
  },

  {
    path: 'engage-schlage-mobile-access-credentials',
    component: InventoryPageComponent,
    data: { header: true },
    canActivate: [CanActivateService],
    children: [],
  },

  {
    path: 'BLE-API-credentials',
    component: APILandingPageComponent,
    data: { header: true },
    canActivate: [CanActivateService],
    children: [
      {
        path: ':integrationId',
        component: ApiDetailsPageComponent,
        data: { header: true },
      },
    ],
  },

  {
    path: 'onboarding-form',
    component: OnboardingComponent,
    data: { header: true },
    canActivate: [CanActivateService],
  },
  {
    path: 'onboarding-list',
    component: OnboardingListComponent,
    data: { header: true },
    canActivate: [CanActivateService],
  },

  {
    path: 'available-subscriptions',
    component: AvailableSubsComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },

  {
    path: 'add-payment-method',
    component: UpdatePaymentComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },

  {
    path: 'active-subscription',
    component: ActiveSubsComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },

  {
    path: 'all-subscriptions',
    component: AllSubsPageComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },

  {
    path: 'zentra-subscriptions-config',
    component: ZentraConfigPageComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },

  {
    path: 'zentra-subscriptions',
    component: ZentraAdminLandingPageComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },
  {
    path: 'zentra-subscriptions-config/:recordId',
    component: ZentraConfigPageComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },

  {
    path: 'zentra-subscription/:recordId',
    component: PropertyManagerLandingComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },
  {
    path: 'zentra-integrator',
    component: IntegratorLandingComponent,
    data: { header: true },
    // canActivate: [CanActivateService],
  },
  {
    path: 'zentra-po-subscription/:id',
    component: PoDetailsPage,
    data: { header: true },
    // canActivate: [CanActivateService],
  },
  // ── SAT Admin ──────────────────────────────────────────────────
  {
    path: 'sat-subscriptions',
    component: SatAdminLandingPageComponent,
    data: { header: true },
    canActivate: [CanActivateService],
  },
  {
    path: 'sat-subscriptions-config',
    component: SatConfigPageComponent,
    data: { header: true },
  },
  {
    path: 'sat-subscriptions-config/:recordId',
    component: SatConfigPageComponent,
    data: { header: true },
  },
  {
    path: 'overtur-admin-subscriptions',
    component: LandingSubListPageComponent,
    data: { header: true },
    canActivate: [CanActivateService],
  },
  {
    path: 'overtur-create-trial-subscriptions',
    component: CreateTrialPageComponent,
    data: { header: true },
  },
  {
    path: 'overtur-subscription-details',
    component: OvertursubDetailsPageComponent,
    data: { header: true },
  },
  {
    path: 'partner-mgmt',
    component: UserPermsComponent,
    data: { header: true },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
